var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNxAlertCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm0-30.251C8.129 1.749 1.749 8.129 1.749 16S8.129 30.251 16 30.251c7.871 0 14.251-6.38 14.251-14.251S23.871 1.749 16 1.749z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.785 20.8v-.02c0-.201.042-.393.118-.567.074-.171.181-.325.311-.454a1.54 1.54 0 0 1 2.142 0c.269.258.437.621.437 1.023v.021c0 .204-.042.398-.118.574a1.431 1.431 0 0 1-.319.453 1.516 1.516 0 0 1-.471.303 1.542 1.542 0 0 1-.593.118h-.023c-.212 0-.414-.042-.599-.118a1.444 1.444 0 0 1-.864-1.322v-.03zm2.78-11.1v4.9a13.048 13.048 0 0 1-.107 1.63q-.093.713-.238 1.518h-1.8q-.157-.8-.245-1.583a12.527 12.527 0 0 1-.1-1.563V9.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNxAlertCircle);
export default __webpack_public_path__ + "static/media/nx-alert-circle.f4cca081.svg";
export { ForwardRef as ReactComponent };